import { connect, useDispatch } from 'react-redux';
import { reduxForm, Field, change } from 'redux-form';
import { Input, Textarea, AutoCompleteSelect, RadioGroup } from '../../../../../../itrust_common/components/form'
import DateFormatView from '../../../../../../itrust_common/components/others/DateFormatView';

let LabOrderForm = props => {
  const { handleSubmit, updatedAt, sentAt, form, pdfAttributes, storeId } = props;
  const dispatch = useDispatch()

  return (
    <form onSubmit={handleSubmit}>
      <div className="d-flex align-items-end">
        <Field label="Send Securely"
          name="contact_id"
          displayName="company_name"
          component={AutoCompleteSelect}
          onChangeHook={(data) => dispatch(change(form, 'account_number', data.account_number))}
          klass="Contact"
          filter={{ store_id: storeId }}
          textField="company_name"
          valueField="id"
          placeholder=""
          className="form-control"
          wrapperClasses="col-6 form-group"
          labelClasses="w-100" />
        <div className="mb-5">
          <div>
            Created At:
            <span className="text-muted ml-2">
              {updatedAt && <DateFormatView dateTime={updatedAt} />}
            </span>
          </div>
          {sentAt &&
            <div>
              Sent At:
              <span className="text-muted ml-2">
                <DateFormatView dateTime={sentAt} />
              </span>
            </div>
          }
        </div>
      </div>
      <Field name="account_number" label="Account Number" component={Input} className="form-control" wrapperClasses="col-12 form-group" />
      <Field name="message" label="Message to Lab" component={Textarea} rows="5" className="form-control" wrapperClasses="col-12 form-group" />
      <RadioGroup name="is_urgent" options={[{ label: "Yes", value: true }, { label: "No", value: false }]} label="Mark as urgent" wrapperClasses="col-6 pb-5" />
      {pdfAttributes &&
        <div className='col-12 pb-5'>
          <a download target="_blank" href={pdfAttributes.file.url} alt={pdfAttributes.filename} className="btn btn-outline-primary mr-5">
            <span className="d-flex"><i className='la la-cloud-download mr-3' />Download PDF</span>
          </a>
        </div>
      }
    </form>
  )
}

LabOrderForm = reduxForm({
  form: 'labOrderForm',
  enableReinitialize: true,
})(LabOrderForm)

LabOrderForm = connect(state => {
  const { labOrder, order: { order } } = state
  return {
    storeId: order.store_id,
    updatedAt: labOrder.lab_order.updated_at,
    sentAt: labOrder.lab_order.sent_at,
    pdfAttributes: labOrder.lab_order.pdf_attributes,
    initialValues: {
      is_urgent: false,
      orders_order_id: order.id,
      ...labOrder.lab_order
    }
  }
})(LabOrderForm)

export default LabOrderForm;